/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{complex as t}from"../../value/types/complex/index.js";const r=(r,e)=>"zIndex"!==r&&(!("number"!=typeof e&&!Array.isArray(e))||!("string"!=typeof e||!t.test(e)&&"0"!==e||e.startsWith("url(")));export{r as isAnimatable};
//# sourceMappingURL=is-animatable.js.map
